import utils from "../utils";

function initImgtosvg() {
	//START Replace all SVG images with inline SVG
	var imgs = document.querySelectorAll('img.svg');
	if (imgs.length > 0) {
		utils.forEach(imgs, function (index, elem) {
			var $img = elem;
			var imgID = $img.id;
			var imgClass = $img.getAttribute('class');
			var imgURL = $img.src;

			utils.ajaxLoad(imgURL, 'GET', null, 'document', null, function (data) {

				// Get the SVG tag, ignore the rest
				var $svg = data.querySelector('svg');

				// Add replaced image's ID to the new SVG
				if (imgID && typeof imgID !== 'undefined') {
					$svg.id = imgID;
				}
				// Add replaced image's classes to the new SVG
				if (imgClass && typeof imgClass !== 'undefined') {
					$svg.setAttribute('class', imgClass + ' replaced-svg');
				}

				// Remove any invalid XML tags as per http://validator.w3.org
				$svg.removeAttribute('xmlns:a');

				// Check if the viewport is set, if the viewport is not set the SVG wont't scale.
				if (!$svg.getAttribute('viewBox') && $svg.getAttribute('height') && $svg.getAttribute('width')) {
					$svg.setAttribute('viewBox', '0 0 ' + $svg.getAttribute('height') + ' ' + $svg.getAttribute('width'))
				}

				// Replace image with new SVG
				$img.replaceWith($svg);

			});

		});
	}
	//STOP Replace all SVG images with inline SVG
}

export default {
	initImgtosvg,
};

/*
function initImgtosvg() {

    document.querySelectorAll('img').forEach((el) => {

        console.log(el);

        if( el.src.includes('.svg')){
            const imgID = el.getAttribute('id');
            const imgClass = el.getAttribute('class');
            const imgURL = el.getAttribute('src');
      
            fetch(imgURL)
                .then(data => data.text())
                .then(response => {
                      const parser = new DOMParser();
                      const xmlDoc = parser.parseFromString(response, 'text/html');
                      let svg = xmlDoc.querySelector('svg');
      
                      if (typeof imgID !== 'undefined') {
                          svg.setAttribute('id', imgID);
                      }
      
                      if(typeof imgClass !== 'undefined') {
                          svg.setAttribute('class', imgClass + ' replaced-svg');
                      }
      
                      svg.removeAttribute('xmlns:a');
      
                      el.parentNode.replaceChild(svg, el);
                })
        }
    });

}

export default { initImgtosvg };

*/